import React, { useRef, useState, useEffect } from "react";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import axios from "axios";
import toast from "react-hot-toast";
import { Helmet } from "react-helmet";

import axiosInstance from "../../axiosInstance";

import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useBlogContext } from "../../fetchdata/BlogContext";
import Select from 'react-select';
import CreateSlug from "../components/extra/CreateSlug";
import NavBar from "../components/NavBar";


const Home = () => {


  const {

    isLayoutLoading,
    layout, splashScreen, AllHomeProducts, isProducts, Headers, IsBlogLoading, AllBlogs, AllCategoriess, LocationHeaders
  } = useBlogContext();




  useEffect(() => {
    window.scrollTo(0, 0);
    console.log('HeadersHeaders', Headers.gold, Headers.sliver)
  }, []);


  const swiperRef = useRef();

  const swiperRefLocal = useRef();

  const handleMouseEnter = () => {
    swiperRefLocal?.current?.swiper?.autoplay?.stop();
  };

  const handleMouseLeave = () => {
    swiperRefLocal?.current?.swiper?.autoplay?.start();
  };


  const [formData, setFormData] = useState({});


  //   const filteredLocations = LocationHeaders.filter((location) =>
  //   location.toLowerCase().includes(searchQuery.toLowerCase())
  // );



  const navigate = useNavigate();


  const [goldRates, setGoldRates] = useState({});
  const [silverPrice, setSilverPrice] = useState(null);

  useEffect(() => {
    // Instead of API
    const gold10gm = Headers.gold;     // 24KT price for 10gm
    const silver10gm = Headers.sliver; // Silver price for 10gm

    // Convert 10gm → 1gm
    const goldPerGram = gold10gm / 10;
    const silverPerGram = silver10gm / 10;

    setGoldRates({
      "24KT": goldPerGram,
      "22KT": goldPerGram * (22 / 24),
      "18KT": goldPerGram * (18 / 24),
      "14KT": goldPerGram * (14 / 24),
    });

    setSilverPrice(silverPerGram);
  }, [Headers]);



  return (
    <>



      <main className="page-content  mypadding bg-light overflow-auto pb-4  px-0"  >

        <Header />


        <div className="bg-white p-0 position-relative  mb-3" onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave} style={{ zIndex: 2 }} >
          <Swiper
            slidesPerView={1}
            spaceBetween={30}
            pagination={{
              clickable: true,
            }}
            navigation={false}
            breakpoints={{
              300: {
                slidesPerView: 1,
              },
              640: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 1,
              },
              1024: {
                slidesPerView: 1,
              },
            }}
            ref={swiperRefLocal}
            autoplay={{
              delay: 1500,
              pauseOnMouseEnter: true,
            }}
            loop={true}
            modules={[Pagination, Navigation, Autoplay]} className="book-now pb-0 ">

            {isLayoutLoading
              ? Array.from({ length: 4 }).map((_, index) => (
                <SwiperSlide
                  className="skeleton"
                  style={{
                    width: "100%",
                    aspectRatio: "197/82"
                  }}
                ></SwiperSlide>
              ))
              : (
                <>

                  {layout.home_slider && (
                    <>
                      {layout.home_slider.map((image, index) => (

                        <SwiperSlide key={index}
                          className="skeleton"
                          style={{
                            width: "100%",
                            aspectRatio: "197/82"
                          }} >
                          <div className="link-dark">
                            <img
                              className="img-fluid w-100"
                              src={image}
                              alt="Preview"
                              id={`imageinputN1${index + 1}`}
                            />
                          </div>
                        </SwiperSlide>


                      ))}
                    </>
                  )}


                </>
              )}


          </Swiper>
        </div>


        <section className="px-2 mb-3">
          <div className="bg-primary rounded overflow-hidden" onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave} style={{ zIndex: 2 }} >
            <Swiper
              slidesPerView={1}
              spaceBetween={30}

              navigation={true}
              breakpoints={{
                300: {
                  slidesPerView: 1,
                },
                640: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 1,
                },
                1024: {
                  slidesPerView: 1,
                },
              }}
              ref={swiperRefLocal}
              autoplay={{
                delay: 1500,
                pauseOnMouseEnter: true,
              }}
              loop={true}
              modules={[Pagination, Navigation, Autoplay]} className="book-now pb-0 ">

              {isLayoutLoading && !Headers
                ? Array.from({ length: 4 }).map((_, index) => (
                  <SwiperSlide
                    className="skeleton"
                    style={{
                      width: "100%",
                      aspectRatio: "552/88"
                    }}
                  ></SwiperSlide>
                ))
                :
                <>


                  <SwiperSlide className="">
                    <div className="d-flex">
                      <div className="col text-white" style={{ borderRight: '0.1px solid white' }}>
                        <div className="px-2">
                          <p className="m-0 p-0 pt-2 text-center">
                            <i className="ri-coin-fill me-2 " style={{ color: 'gold' }} />
                            Current Gold Rate   </p>
                        </div>
                        <div className="py-2" style={{ borderBottom: '0.5px solid white' }} />
                        <div className="px-2 pt-2 text-center">
                          <p><strong>Gold 24KT:</strong> ₹{goldRates["24KT"] ? Math.floor(goldRates["24KT"]) : "Loading..."} </p>
                        </div>
                      </div>
                      <div className="col text-white" style={{ borderRight: '0.1px solid white' }}>
                        <div className="px-2">
                          <p className="m-0 p-0 pt-2 text-center">
                            <i className="ri-coin-fill me-2 " style={{ color: 'gold' }} />
                            Current Gold Rate   </p>
                        </div>
                        <div className="py-2" style={{ borderBottom: '0.5px solid white' }} />
                        <div className="px-2 pt-2 text-center">
                          <p><strong>Gold 22KT:</strong> ₹{goldRates["22KT"] ? Math.floor(goldRates["22KT"]) : "Loading..."} </p>
                        </div>
                      </div>

                    </div>
                  </SwiperSlide>

                  <SwiperSlide className="">
                    <div className="d-flex">
                      {/* Gold 24KT */}
                      <div className="col text-white" style={{ borderRight: '0.1px solid white' }}>
                        <div className="px-2">
                          <p className="m-0 p-0 pt-2 text-center">
                            <i className="ri-coin-fill me-2 " style={{ color: 'gold' }} />
                            Current Gold Rate
                          </p>
                        </div>
                        <div className="py-2" style={{ borderBottom: '0.5px solid white' }} />
                        <div className="px-2 pt-2 text-center">
                          <p><strong>Gold 24KT:</strong> ₹{goldRates["24KT"] ? Math.floor(goldRates["24KT"]) : "Loading..."}</p>
                        </div>
                      </div>

                      {/* Gold 22KT */}
                      <div className="col text-white" style={{ borderRight: '0.1px solid white' }}>
                        <div className="px-2">
                          <p className="m-0 p-0 pt-2 text-center">
                            <i className="ri-coin-fill me-2 " style={{ color: 'gold' }} />
                            Current Gold Rate
                          </p>
                        </div>
                        <div className="py-2" style={{ borderBottom: '0.5px solid white' }} />
                        <div className="px-2 pt-2 text-center">
                          <p><strong>Gold 22KT:</strong> ₹{goldRates["22KT"] ? Math.floor(goldRates["22KT"]) : "Loading..."}</p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide className="">
                    <div className="d-flex">

                      {/* Gold 18KT */}
                      <div className="col text-white" style={{ borderRight: '0.1px solid white' }}>
                        <div className="px-2">
                          <p className="m-0 p-0 pt-2 text-center">
                            <i className="ri-coin-fill me-2 " style={{ color: 'gold' }} />
                            Current Gold Rate
                          </p>
                        </div>
                        <div className="py-2" style={{ borderBottom: '0.5px solid white' }} />
                        <div className="px-2 pt-2 text-center">
                          <p><strong>Gold 18KT:</strong> ₹{goldRates["18KT"] ? goldRates["18KT"].toFixed(2) : "Loading..."}</p>
                        </div>
                      </div>

                      {/* Gold 14KT */}
                      <div className="col text-white" style={{ borderRight: '0.1px solid white' }}>
                        <div className="px-2">
                          <p className="m-0 p-0 pt-2 text-center">
                            <i className="ri-coin-fill me-2 " style={{ color: 'gold' }} />
                            Current Gold Rate
                          </p>
                        </div>
                        <div className="py-2" style={{ borderBottom: '0.5px solid white' }} />
                        <div className="px-2 pt-2 text-center">
                          <p><strong>Gold 14KT:</strong> ₹{goldRates["14KT"] ? goldRates["14KT"].toFixed(2) : "Loading..."}</p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide className="">
                    <div className="d-flex">

                      {/* Silver */}
                      <div className="col text-white" style={{ borderRight: '0.1px solid white' }}>
                        <div className="px-2">
                          <p className="m-0 p-0 pt-2 text-center">
                            <i className="ri-coin-fill me-2 " style={{ color: 'silver' }} />
                            Silver Price
                          </p>
                        </div>
                        <div className="py-2" style={{ borderBottom: '0.5px solid white' }} />
                        <div className="px-2 pt-2 text-center">
                          <p><strong>Silver:</strong> ₹{silverPrice ? silverPrice.toFixed(2) : "Loading..."}</p>
                        </div>
                      </div>


                    </div>
                  </SwiperSlide>



                </>
              }


            </Swiper>
          </div>
        </section>



        <div className=" p-0 position-relative mt-3" onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave} style={{ zIndex: 2 }} >
          <Swiper
            slidesPerView={1}
            spaceBetween={12}
            pagination={false}
            navigation={false}
            breakpoints={{
              300: {
                slidesPerView: 2.8,
              },
              640: {
                slidesPerView: 2.8,
              },
              768: {
                slidesPerView: 2.8,
              },
              1024: {
                slidesPerView: 3.2,
              },
            }}
            ref={swiperRefLocal}
            autoplay={{
              delay: 1200,
              pauseOnMouseEnter: true,
            }}
            loop={true}
            modules={[Pagination, Navigation, Autoplay]} className="book-now pb-0 ">

            {isLayoutLoading
              ? Array.from({ length: 4 }).map((_, index) => (
                <SwiperSlide
                  className="skeleton rounded"
                  style={{
                    width: "100%",
                    aspectRatio: "179/179",

                  }}
                ></SwiperSlide>
              ))
              : (
                <>

                  {layout.latest_product_banner && (
                    <>
                      {layout.latest_product_banner.map((image, index) => (


                        <SwiperSlide key={index} >
                          <Link to={image?.imageUrlInput} className="text-white bg-white  text-center d-block pb-0 pt-2 rounded border overflow-hidden" >
                            <img
                              src={image?.imageInput}
                              className="img-fluid d-block p-4 mx-auto"
                              alt="img"
                              style={{ aspectRatio: '1/1', width: 100 }}
                            />
                            <p className="m-0 bg-primary p-2 text-truncate small"> {image?.imageTITInput} </p>
                          </Link>
                        </SwiperSlide>



                      ))}
                    </>
                  )}



                </>
              )}


          </Swiper>
        </div>



        <div className=" p-0 position-relative mt-3" onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave} style={{ zIndex: 2 }} >
          <Swiper
            slidesPerView={1}
            spaceBetween={12}
            pagination={false}
            navigation={false}
            breakpoints={{
              300: {
                slidesPerView: 2.8,
              },
              640: {
                slidesPerView: 2.8,
              },
              768: {
                slidesPerView: 2.8,
              },
              1024: {
                slidesPerView: 3.2,
              },
            }}
            ref={swiperRefLocal}
            autoplay={{
              delay: 1000,
              pauseOnMouseEnter: true,
            }}
            loop={true}
            modules={[Pagination, Navigation, Autoplay]} className="book-now pb-0 ">

            {isLayoutLoading
              ? Array.from({ length: 4 }).map((_, index) => (
                <SwiperSlide
                  className="skeleton"
                  style={{
                    width: "100%",
                    aspectRatio: "179/222",
                    borderRadius: '100px 100px 0px 0px'
                  }}
                ></SwiperSlide>
              ))
              : (
                <>

                  {layout.trending_product_banner && (
                    <>
                      {layout.trending_product_banner.map((image, index) => (


                        <SwiperSlide key={index} >
                          <Link to={image?.imageUrlInput} className="text-white bg-primary text-center d-block pb-3 pt-2" style={{ borderRadius: '100px 100px 0px 0px' }}>
                            <img
                              src={image?.imageInput}
                              className="img-fluid d-block p-4 w-100"
                              alt="img"
                              style={{ aspectRatio: '1/1' }}
                            />
                            <p className="m-0"> {image?.imageTITInput} </p>
                          </Link>
                        </SwiperSlide>



                      ))}
                    </>
                  )}



                </>
              )}


          </Swiper>
        </div>


        <section className="my-4">

          {isLayoutLoading
            ? Array.from({ length: 4 }).map((_, index) => (
              <div
                className="skeleton"
                style={{
                  width: "100%",
                  aspectRatio: "197/90"
                }}
              ></div>
            ))
            : (
              <>

                {layout.trending_product_carousal && (
                  <>
                    {layout.trending_product_carousal.map((image, index) => (

                      <img key={index} src={image?.imageInput} className="d-block w-100 mb-4" alt="banner" />


                    ))}
                  </>
                )}

              </>)}




        </section>

        <NavBar />

      </main>


    </>
  );
};

export default Home;
